import React from 'react'
import Stream from '../components/Stream'

const LiveStream = () => {
   const videoUrl = 'https://www.youtube.com/live/_eGJ7_R5pXA?si=BdZgjerk4oFktNSs'
  return (
    <div className="App text-center mx-auto max-w-screen-lg">
      <h1 className="text-2xl font-bold my-4">YouTube Video Streamer</h1>
      <Stream videoUrl={videoUrl} />
    </div>
  )
}

export default LiveStream